import { Dispatch, SetStateAction, createContext, useState } from 'react'
import { WidgetFilter } from '~/types/FilterTypes'
import { WidgetDataStatus } from '../../types/WidgetTypes'

type ContextProps = {
    controlWidget: ControlWidget
    filterByWidgetId: FilterByWidgetId
    id: string
    topLabelData: IData
    setTopLabelData: Dispatch<SetStateAction<IData>>
    setFilterByWidgetId: Dispatch<SetStateAction<FilterByWidgetId>>
    updateControlWidgetStatus: (status: WidgetDataStatus) => void
    updateControlWidgetValue: (value: string) => void
}

interface FilterByWidgetId {
    [widgetId: string]: WidgetFilter
}

interface ControlWidget {
    /** id of the widget in the perspective that has control */
    id: string
    /** status of the control widget. Starts at fetching and goes to done or no-data based on result */
    status: WidgetDataStatus
    /** selectedvalue of the control widget  */
    value: string
}

interface IData {
    [key: string]: string
}

const PerspectiveContext = createContext<Partial<ContextProps>>({})

function PerspectiveProvider({ configs, children, id }) {
    const controlWidgetId = configs.find(c => c.ForControl)?.Id
    const [filterByWidgetId, setFilterByWidgetId] = useState<FilterByWidgetId>({})
    const [topLabelData, setTopLabelData] = useState<IData>({})
    const [controlWidget, setControlWidget] = useState<ControlWidget>(
        controlWidgetId ? { id: controlWidgetId, status: 'fetching', value: null } : null
    )

    return (
        <PerspectiveContext.Provider
            value={{
                controlWidget,
                filterByWidgetId,
                id,
                topLabelData,
                setTopLabelData,
                setFilterByWidgetId,
                updateControlWidgetStatus: status => setControlWidget(s => ({ ...s, status })),
                updateControlWidgetValue: value => setControlWidget(s => ({ ...s, value })),
            }}
        >
            {children}
        </PerspectiveContext.Provider>
    )
}

export { PerspectiveContext, PerspectiveProvider }
